/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown> }} History_Transfer_Done_SkippedInputs */

const en_us2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} sets were left out (no matching exercise, or nothing to log).`)
};

const pt_br2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries ficaram de fora (sem exercício correspondente ou sem nada para registrar).`)
};

const es_419_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} series quedaron fuera (sin ejercicio correspondiente o sin nada que registrar).`)
};

const pt_pt2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries ficaram de fora (sem exercício correspondente ou sem nada para registar).`)
};

const fr_fr2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries ont été laissées de côté (aucun exercice correspondant, ou rien à enregistrer).`)
};

const de_de2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} Sätze wurden ausgelassen (keine passende Übung oder nichts zu erfassen).`)
};

const it_it2_history_transfer_done_skipped = /** @type {(inputs: History_Transfer_Done_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} serie sono rimaste fuori (nessun esercizio corrispondente o niente da registrare).`)
};

/**
* | output |
* | --- |
* | "{sets} sets were left out (no matching exercise, or nothing to log)." |
*
* @param {History_Transfer_Done_SkippedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_done_skipped = /** @type {((inputs: History_Transfer_Done_SkippedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Done_SkippedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_done_skipped(inputs)
	if (locale === "es-419") return es_419_history_transfer_done_skipped(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_done_skipped(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_done_skipped(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_done_skipped(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_done_skipped(inputs)
	return en_us2_history_transfer_done_skipped(inputs)
});
export { history_transfer_done_skipped as "history-transfer.done_skipped" }